import {
  GET_NORMSLIBRARY_FAIL,
  GET_NORMSLIBRARY_SUCCESS,
  GET_NORMSLIBRARYS_FAIL,
  GET_NORMSLIBRARYS_SUCCESS,
  ADD_NORMSLIBRARY_SUCCESS,
  ADD_NORMSLIBRARY_FAIL,
  UPDATE_NORMSLIBRARY_SUCCESS,
  UPDATE_NORMSLIBRARY_FAIL,
  DELETE_NORMSLIBRARY_SUCCESS,
  DELETE_NORMSLIBRARY_FAIL,  
  SET_STATE_NORMSLIBRARY
} from "./actionTypes";

const INIT_STATE = {
  normsLibrarys: [],
  normsLibrary: {},
  error: {},
  loading: false,
  total: 0,
  currentPage: 0,
};

const normsLibrarys = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_NORMSLIBRARYS_SUCCESS:
      return {
        ...state,
        normsLibrarys: action.payload.normsLibrarys,
        total: action.payload.total,
        currentPage: action.payload.currentPage,
      };

    case SET_STATE_NORMSLIBRARY:
      return { ...state, loading: action.payload }

    case GET_NORMSLIBRARYS_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case ADD_NORMSLIBRARY_SUCCESS:
      return {
        ...state,
        normsLibrarys: [...state.normsLibrarys, action.payload],
      };

    case ADD_NORMSLIBRARY_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case UPDATE_NORMSLIBRARY_SUCCESS:
      return {
        ...state,
        normsLibrarys: state.normsLibrarys.map(normsLibrary =>
          normsLibrary.id.toString() === action.payload.id.toString()
            ? { ...action.payload, normsLibrary }
            : normsLibrary
        ),
      };

    case UPDATE_NORMSLIBRARY_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case DELETE_NORMSLIBRARY_SUCCESS:
      return {
        ...state,
        normsLibrarys: state.normsLibrarys.filter(
          normsLibrary => normsLibrary.id.toString() !== action.id.toString()
        ),
      };

    case DELETE_NORMSLIBRARY_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case GET_NORMSLIBRARY_SUCCESS:
      return {
        ...state,
        normsLibrary: action.payload,
      };

    case GET_NORMSLIBRARY_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default normsLibrarys;
